<template>
  <div>
    {{ display }}
  </div>
</template>

<script>
import cellRendererMixin from '../../mixins/cellRenderer.mixin'

export default {
  mixins: [cellRendererMixin]

}
</script>
